/* eslint-disable react/jsx-filename-extension */

// import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import "./assets/css/app.scss";
import { ToastContainer } from "react-toastify";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./app/store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar="false"
      newestOnTop="true"
      closeOnClick
      rtl={false}
      draggable
      theme="light"
      limit="2"
    />
    <App />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
